<form
	[formGroup]="form"
	class="new-card-form"
	novalidate
	(submit)="$event.preventDefault()"
	(ngSubmit)="submitForm()"
>
	<div class="new-card-form__header mb-4">
		<h3 class="h5 fw-semibold mb-2">Card details</h3>
		<p class="text-muted small mb-0">
			Information is encrypted and processed by Stripe. AtomicTax never sees your full card number or CVC.
		</p>
	</div>

	<div class="row g-3">
		<div class="col-12">
			<label class="form-label small fw-semibold text-secondary" for="new-card-number">Card number</label>
			<input
				id="new-card-number"
				class="form-control form-control-lg"
				formControlName="cardNumber"
				type="text"
				inputmode="numeric"
				autocomplete="cc-number"
				placeholder="4242 4242 4242 4242"
				spellcheck="false"
				[attr.aria-invalid]="form.controls.cardNumber.invalid && form.controls.cardNumber.touched"
			/>
		</div>

		<div class="col-sm-4">
			<label class="form-label small fw-semibold text-secondary" for="new-card-exp-month">Month</label>
			<input
				id="new-card-exp-month"
				class="form-control"
				formControlName="cardExpMonth"
				type="text"
				inputmode="numeric"
				autocomplete="cc-exp-month"
				placeholder="MM"
				maxlength="2"
				spellcheck="false"
				[attr.aria-invalid]="form.controls.cardExpMonth.invalid && form.controls.cardExpMonth.touched"
			/>
		</div>
		<div class="col-sm-4">
			<label class="form-label small fw-semibold text-secondary" for="new-card-exp-year">Year</label>
			<input
				id="new-card-exp-year"
				class="form-control"
				formControlName="cardExpYear"
				type="text"
				inputmode="numeric"
				autocomplete="cc-exp-year"
				placeholder="YY"
				maxlength="4"
				spellcheck="false"
				[attr.aria-invalid]="form.controls.cardExpYear.invalid && form.controls.cardExpYear.touched"
			/>
		</div>
		<div class="col-sm-4">
			<label class="form-label small fw-semibold text-secondary" for="new-card-cvv">
				Security code
			</label>
			<input
				id="new-card-cvv"
				class="form-control"
				formControlName="cardCVV"
				type="text"
				inputmode="numeric"
				autocomplete="cc-csc"
				placeholder="CVC"
				maxlength="4"
				spellcheck="false"
				[attr.aria-invalid]="form.controls.cardCVV.invalid && form.controls.cardCVV.touched"
			/>
			<span class="form-text">Usually 3 digits on the back; Amex uses 4 on the front.</span>
		</div>

		<div class="col-12 pt-2">
			<button
				type="button"
				[disabled]="isLoading || form.invalid"
				class="btn btn-primary btn-lg w-100"
				data-test-id="new-card-submit"
				(click)="submitForm()"
			>
				<span class="mdi mdi-lock-outline me-1" aria-hidden="true"></span>
				Save card securely
				<i *ngIf="isLoading" aria-hidden="true" class="mdi mdi-cisco-webex mdi-spin ms-2"></i>
			</button>
		</div>
	</div>
</form>
